import { FormEvent, useState } from "react";
import { Event, EventType } from "../../libs/data/event";
import { RegistrationSteps } from "../../libs/registration/registration-steps";
import {
  registrationInfoStore,
  useRegistration,
} from "../../libs/registration/registration.hook";
import { AppForm } from "../form/styles/app-form";
import { BackButton } from "../form/styles/back-button";
import { CtaButton } from "../form/styles/cta-button";
import { StudentInfoComp } from "./student-info.comp";

export const StudentInfoListComp = (props: {
  currentEvent?: Event;
  setStep: (step: RegistrationSteps) => void;
}) => {
  const { currentEvent } = props;
  const { registrationInfo, setRegistrationInfo, writeRegistrationInfo } =
    useRegistration();
  const students = registrationInfo.students
    ? Object.entries(registrationInfo.students)
    : [];
  const isSchedule = currentEvent?.type === EventType.Schedule;

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();

    writeRegistrationInfo();
    props.setStep(RegistrationSteps.TermsAndConditions);
  };

  const onAddStudent = (event: FormEvent) => {
    event.preventDefault();

    setRegistrationInfo({
      students: {
        ...registrationInfoStore.students,
        [students.length]: {},
      },
    });
  };

  const onAddFood = (event: FormEvent) => {
    setRegistrationInfo({
      foodOption:
        !registrationInfo.foodOption || registrationInfo.foodOption === "no"
          ? "yes"
          : "no",
    });
  };

  const onAddExtendedHours = (event: FormEvent) => {
    setRegistrationInfo({
      extendedHours:
        !registrationInfo.extendedHours ||
        registrationInfo.extendedHours === "no"
          ? "yes"
          : "no",
    });
  };

  const onBack = (event: FormEvent) => {
    event.preventDefault();
    props.setStep(RegistrationSteps.ContactInfo);
  };

  return (
    <AppForm className="scrollable" onSubmit={onSubmit}>
      {students.map(([id]) => (
        <>
          <h2>Child {parseInt(id) + 1} Info </h2>
          <AppForm>
            <StudentInfoComp id={id} showSelection />
          </AppForm>
        </>
      ))}
      {students.length < 4 && (
        <CtaButton onClick={onAddStudent}>+ Add Child</CtaButton>
      )}
      <br />
      {currentEvent?.type === EventType.Camp && (
        <h2>
          <input
            type="checkbox"
            checked={registrationInfo.foodOption === "yes"}
            onChange={onAddFood}
          />{" "}
          <strong>Add food option</strong>
        </h2>
      )}
      {currentEvent?.type === EventType.Camp && (
        <h2>
          <input
            type="checkbox"
            checked={registrationInfo.extendedHours === "yes"}
            onChange={onAddExtendedHours}
          />{" "}
          <strong>Add extended hours option</strong>
        </h2>
      )}
      <br />
      <br />
      <div>
        <BackButton onClick={onBack}>Back</BackButton>
        <CtaButton>Next</CtaButton>
      </div>
    </AppForm>
  );
};
